import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "board-body" }
const _hoisted_2 = {
  key: 0,
  class: "board-text"
}
const _hoisted_3 = ["src"]

import { computed, ref, watch } from 'vue';
import { loadBoardImage, splitBoardBody } from '@/utils/boardBody';


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardBody',
  props: {
    body: {}
  },
  setup(__props: any) {

const props = __props;
const urls = ref<Record<string, string>>({});
const parts = computed(() => splitBoardBody(props.body || ''));

watch(parts, async (list) => {
  const next = { ...urls.value };
  await Promise.all(list.filter((part) => part.kind === 'image').map(async (part) => {
    if (part.kind !== 'image' || next[part.file]) return;
    try {
      next[part.file] = await loadBoardImage(part.file);
    } catch (error) {
      console.error('게시 이미지 조회 실패:', error);
    }
  }));
  urls.value = next;
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parts.value, (part, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (part.kind === 'text')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(part.text), 1))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "board-image",
              src: urls.value[part.file] || '',
              alt: ""
            }, null, 8, _hoisted_3))
      ], 64))
    }), 128))
  ]))
}
}

})